<template lang="pug">
.wrapper
  //- div(style='position: fixed; z-index: 999; top: 100px; left: 0; width: 400px;')
    xmp transition {{ transition }}
    xmp current {{ current }}
    xmp currentSlide {{ currentSlide }}
    
  .info-page-wrapper(v-show='projects')
    Info(:info='info')
  
  header(:class='{ "show--info": showInfo, "translucent--bg": (projectView || currentView), "mobile-grey-slide": (mobileGreySlide && st <=0) }')
    .bar(@mouseenter="showMenu = true", @mouseleave="showMenu = false")
      //- name
      transition(name="intro")
        //- .bar(v-show="!titleVisible || !showMenu") 
        .bar(v-show="!projects", style='z-index: 51; background: white !important;') 
          span.heading Matthieu Lavanchy
      
      //- project title
      //- transition(name="bar" mode="in-out")
        //- .bar(v-show="titleVisible")
      .bar(:class="{ 'show--title': titleVisible, 'hidden--title': !titleVisible }")
        span.serif(v-html="title")
      
      //- info link
      //- div
      transition(:name="infoTransition")
        //- .info-link.bar(v-show="projects && !titleVisible")
          div.heading(:class="{'invisible-ink': infoInvisible}" @click="currentClick") Information
        //- div
        //- navv(:visible="projects && !titleVisible", type='top')
        .bar(v-show='(showMenu && !projectViewMobile) || (showInfo && !projectViewMobile)')
          navv(type='top' :visible="true", :showInfo='showInfo')
      
    
  .projects(:class="classes")
    //-  @mouseenter="hideTitle"
    transition(name="intro")
      .main(ref="scrollbody", v-if="projects")
        
        #current(ref='current')
          current(:current='currentData')
        
        #projects.thumbs(ref='projects')
          //- , v-view="viewHandler"
          div(v-for="(project, index) in projects")
            a(:style="'background-image: url(' + thumb(project) + ')'",
              :data-imgsize="thumbSize",
              @click="open(index)", 
              @mouseenter="thumbHover(project.data.title)", 
              @mouseleave="hideTitle(200)") 
        
        #viewer(ref="viewer", @click="viewerClick") 
          transition-group(:name="transition")
            project(
              v-for="(project, index) in projects", 
              :key="index", 
              v-if="index === current", 
              :title="projectView ? html(project.data.title) : ''", 
              :current="currentSlide", 
              :slides="project.data.slides", 
              :preload="projects[nextIndex].data.slides",
              :transition="transition",
              @imgHover="showTitle(project.data.title, true)",
              @imgLeave="hideTitle")
</template>

<script>
import Navv from '@/components/Nav'
import Project from '@/components/Project'
import Current from '@/components/Current'
import Info from '@/components/Info'

import Vue from 'vue'
import _throttle from 'lodash/throttle'
import VueScrollTo from 'vue-scrollto' // '@/scripts/scrollTo'
// import VueScrollTo from '@/scripts/scrollTo'
const Modernizr = window.Modernizr

export default {
  name: "Projects",
  props: ['projects', 'entering', 'savedPosition', 'currentData', 'info'],
  inheritAttrs: false,
  components: {
    Project,
    Current,
    Navv,
    Info
  },
  data () {
    return {
      grayBg: false,
      leaving: false,
      projectView: false,
      transition: null,
      current: 0,
      currentSlide: 1,
      title: '',
      titleVisible: false,
      titleTmOut: null,
      nearProjectView: false,
      snapTmOut: null,
      infoInvisible: false,
      sliderThrottle: 850, // window.innerWidth > Vue.config.bkpt.mobile ? 950 : 700
      showMenu: true,
      showInfo: false,
      currentView: true,
      mobileGreySlide: false,
      st: 0,
      // aboveMenu: false,
      // honk: true
    }
  },
  computed: {
    classes () {
      return {
        'projects--projectview': this.projectView || this.$route.name === 'Current',
        'projects--projects-loaded': this.projectsLoaded,
        'projects--animating': this.leaving || this.entering,
        'show--info': this.showInfo,
        'gray--bg': this.grayBg,
        // 'above--menu': this.aboveMenu
      }
    },
    scrollBody () {
      return window
    },
    thumbSize () {
      const w = window.innerWidth
      let size = 'mobile'
      size = w > 414 && w <= Vue.config.bkpt.prjGrid_2col ? 'medium' : size
      size = w > 2048 ? 'large' : size
      return size
    },
    nextIndex () {
      return this.current + 1 === this.projects.length ? 0 : this.current + 1
    },
    infoTransition () {
      return this.infoInvisible ? 'bar' : 'intro'
    },
    projectViewMobile () {
      if (window.innerWidth <= Vue.config.bkpt.mobile) {
        // is mobile
        if (this.projectView) return true
        else if (this.st <= 0) return true
        else return false
      } 
      else return false
    },
  },
  
  watch: {
    projects () {
      this.hideInfoBar(4000)
    },
    $route () {
      const r = this.$route.name
      if (r === 'Info') {
        this.showInfo = true
      } else {
        this.showInfo = false
      }
      if (r === 'Current') {
        this.currentView = true
      } else {
        this.currentView = false
      }
    },
    // entering (entering) {
    //   if (entering) {
    //     this.$nextTick(() => {
    //       // this.$refs.scrollbody.scrollTop = this.savedPosition
    //     })
    //   } else { // entered
    //     this.$nextTick(() => {
    //       document.body.scrollTop = this.savedPosition
    //     })
    //   }
    // },
    projectView (entering) {
      // console.log('projectView', entering)
      // if (entering) {
      //   this.hideTitle()
      // } else { // leaving
      //   if (this.projects) {
      //     this.showTitle(this.projects[this.current].data.title)
      //     this.hideTitle(1200)
      //   }
      // }
    },
    
    infoInvisible () {
      // console.log('infoInvisible', this.infoInvisible)
    },
    title () {
      // console.log('title', this.title)
    }
  },

  methods: {
    handleScroll (e) {
      const st = this.$refs.scrollbody.scrollTop
      const projects = this.$refs.projects
      const projectsDistanceTop = projects.offsetTop - 200
      const viewer = this.$refs.viewer
      const viewerDistanceTop = viewer.offsetTop - 200
      
      if (st > projectsDistanceTop && st < viewerDistanceTop) {
        // console.log('projects');
        this.$router.push({ name: 'Projects', replace: true })
        this.projectView = false
        this.grayBg = true
      } else if (st > viewerDistanceTop) {
        // console.log('viewer');
        this.projectView = true
        this.grayBg = false
      } else if (st < projectsDistanceTop) {
        // console.log('current');
        this.$router.push({ name: 'Current', replace: true })
        this.projectView = false
        this.grayBg = false
      }
      
      this.st = st
    },

    viewHandler (e) {
      const r = this.$router.currentRoute.name
      
      // console.log(e)
      //  && r !== 'information'
      if (e.percentTop <= 0.85 && r !== 'projects' && e.scrollPercent !== 0 || e.type === 'exit' && e.scrollPercent !== 0 && e.scrollPercent > 1) {
        this.$router.push({ name: 'Projects', replace: true })
        // console.log('projects')
        // console.log(e);
      } else if (r !== 'current' && e.type !== 'exit' && e.percentTop > 0.85) {
        this.$router.push({ name: 'Current', replace: true })
      }
    },
    
    html (key) {
      return Vue.$html(key)
    },
    
    thumb (doc) {
      if (doc.data.thumbnail) {
        const src = doc.data.thumbnail[this.thumbSize]
        return src ? src.url : doc.data.thumbnail.url
      }
      return ''
    },
    
    open (prjIndex) {
      this.current = prjIndex
      // this.currentSlide = 0
      this.currentSlide = 1
      this.transition = 'none'
      this.showTitle(this.projects[this.current].data.title)
      // this.scrollToViewer()
      VueScrollTo.scrollTo('#viewer', 1000, { container: '.main' })
    },
    
    showTitle (prismicText, timeoutOnTouch) {
      // console.log('showTitle')
      if (this.infoInvisible) {
        if (Array.isArray(prismicText)) {
          this.title = Vue.$html(prismicText)
        } else if (typeof prismicText === 'string') {
          this.title = prismicText
        }
        this.titleVisible = true
        // clearTimeout(this.titleTmOut)
        // if (timeoutOnTouch) {
          // if (Modernizr.touchevents) this.hideTitle(2000)
        // }
      }
    },
    hideTitle (delay = 0) {
      // this.titleTmOut = setTimeout(() => { 
        // console.log('hideTitle')
        this.titleVisible = false 
      // }, delay)
    },
    
    thumbHover (key) {
      if (Modernizr) if (!Modernizr.touchevents) this.showTitle(key)
    },
    
    infoClick () {
      this.projectView = false
      const delay = this.projectView ? 200 : 0
      const go = () => { this.$router.push({name: 'Info'}) }
      setTimeout(go, delay)
    },
    
    currentClick () {
      
    },
    projectsClick () {
      
    },
    
    hideInfoBar (delay = 0) {
      // console.log('hideInfoBar', delay)
      // old
      if (this.projects) setTimeout(() => { 
        this.infoInvisible = true 
      }, delay)
      // new
      if (this.projects) setTimeout(() => { 
        
        var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        // if w is less than iphone 13 width
        if (width > 960) {
          this.showMenu = false
        }
      }, delay)
    },
    
    viewerClick (e) {
      const prev = e.clientX - e.target.offsetLeft < e.target.offsetWidth / 2
      if (prev) return this.previous()
      return this.next()
    },
    
    
    next: _throttle(function () {
      this.transition = 'slideleft_old'
      const lastSlide = this.currentSlide + 1 > this.projects[this.current].data.slides.length
      if (lastSlide) {
        this.current = this.current + 1 > this.projects.length - 1 ? 0 : this.current + 1
        this.currentSlide = 0
        this.hideTitle(950)
      } else {
        this.currentSlide++
      }
    }, this.sliderThrottle),
    
    previous: _throttle(function () {
      this.transition = 'slideright_old'
      const firstSlide = this.currentSlide - 1 < 0
      if (firstSlide) {
        this.current = this.current - 1 < 0 ? this.projects.length - 1 : this.current - 1
        this.currentSlide = this.projects[this.current].data.slides.length
      } else {
        this.currentSlide--
        if (this.currentSlide === 0) this.hideTitle(950)
      }
    }, this.sliderThrottle),
    
    scrollToViewer (duration = 1000) {
      this.$nextTick(() => {
        // console.log('HONK HONK');
        if (this.$refs.viewer) return VueScrollTo.scrollTo(this.$refs.viewer, duration)
      })
    },
    
    // onScroll: _throttle(function () {
    //   const viewBottom = window.pageYOffset + window.innerHeight
    //   const scrollBottom = document.body.scrollHeight
    //   // in project view ?
    //   const buffer = window.innerHeight / 8
    //   this.projectView = viewBottom >= scrollBottom - buffer
    //   // snap to project view ?
    //   clearTimeout(this.snapTmOut)
    //   this.snapTmOut = setTimeout(() => {
    //     const offset = window.innerHeight / 3
    //     const nearProjectView = viewBottom >= scrollBottom - offset
    //     if (nearProjectView) this.scrollToViewer(1000)
    //   }, 300)
    // }, 100),
    
    bindScroll () {
      // window.addEventListener('scroll', this.onScroll)
      setTimeout(() => {
        if (this.$refs.scrollbody) {
          this.$refs.scrollbody.addEventListener('scroll', this.handleScroll);
        } else {
          setTimeout(() => {
            this.$refs.scrollbody.addEventListener('scroll', this.handleScroll);
          }, 1110)
        }
      }, 1110);
    }
  },
  
  mounted () {
    this.hideInfoBar(2000)
    this.bindScroll()
  },
  
  // beforeRouteLeave (to, from, next) {
  //   const y = window.pageYOffset
  //   this.leaving = true
  //   this.$nextTick(() => {
  //     this.$refs.scrollbody.scrollTop = y
  //     next()
  //   })
  // },
  
  destroy () {
    window.removeEventListener('scroll', this.onScroll)
    this.$refs.scrollbody.addEventListener('scroll', this.handleScroll);
  }
}
</script>

<style lang="scss" scoped>
  @import '../style/variables';

  @include onMobile() {
    header.mobile-grey-slide {
      transform: translateY(-4rem);
      transition: transform 0.4s ease-in-out;
    }
  }
  
  

  .above--menu {
    // menu is z-index: 200
    z-index: 300
  }
  .bar.hidden--title {
    opacity: 0;
    transition: opacity 0.5s ease-out, background 0.5s, transform 1s ease-in-out;
    transition-delay: 0.2s;
  }
  .bar.show--title {
    opacity: 1;
    transition: opacity 0.3s ease-out, background 0.5s, transform 1s ease-in-out;
  }
  
  /* header .bar {
    transition: background 0.5s;
  } */
  header.translucent--bg .bar {
    background: transparent !important;
    /* transition: background 0.5s; */
  }
  header.show--info {
    transform: translateY(calc(100vh - (4.166666667 * 1rem)));
    @include onMobile() {
      transform: translateY(calc(100vh - (3.6 * 1rem)));
      transform: translateY(calc((var(--vh, 1vh) * 100) - (3.6 * 1rem)));
    }
    /* transition: transform 1s ease-in-out; */
  }
  
  

  .info-page-wrapper {
    position: absolute;
    top: 0;
    width: 100vw;
    background: white;
    height: 100vh;
    overflow-y: auto;
    @include onMobile() {
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  
  header {
    transform: translateY(0);
    transition: transform 0.5s ease-out;
    position: relative;
    width: 100vw;
    z-index: 200;
  }
  
  
  .projects{
    
    position: relative;
    /* background: $color-bg; */
    background: white;
    &.gray--bg {
      background:#eaeaea !important;
    }
    
    &.show--info {
      transform: translateY(calc(100vh - (4.166666667 * 1rem)));
      transition: transform 1s ease-in-out;
      @include onMobile() {
        transform: translateY(calc(100vh - (3.6 * 1rem)));
        transform: translateY(calc((var(--vh, 1vh) * 100) - (3.6 * 1rem)));
      }
    }
    transform: translateY(0);
    /* transition: transform 1s ease-in-out; */
    
    > .main{
      /* padding:$nav-h 0 0; */
    }

    // inner scroll on slide down animations
    &.projects--animating{
      height:100vh;
      height: calc(var(--vh, 1vh) * 100);
      overflow:hidden;
      .main{
        height:100vh;
        height: calc(var(--vh, 1vh) * 100);
        overflow-y:scroll;
      }
    }
    .main{
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      width: 100vw;
      overflow-x: hidden;
      overflow-y: auto;
    }

    // change background on scroll
    transition: background-color $trans-bgfade 0.3s, transform 1s ease-in-out;
    /* &.projects--projectview, &.show--info{
      background-color:$color-wht;
    } */
  }

  header{
    // project view
    transition: background .5s, transform 1s ease-in-out;
    /* background: white; */
    /* height:$nav-h; */
    .projects--projectview &{
      background: transparent;
    }
  }
  
  header .bar{

    // during slide up / down page transition
    .slidedown-leave-active &,
    .slideup-enter-active &{
      transition: all $trans-pageslide !important;
    }
    .slidedown-leave-to &,
    .slideup-enter &{
      background: $color-bg !important;
      color: transparent !important;
    }
    
    // invisible text (info)
    .no-touchevents &{
      span{
        transition:color .5s;  
        &.invisible-ink{
          color:transparent;
        }
      }
      &:hover{
        span{
          color:inherit;
        }
      }
    }
  }

  .info-link{
    &.bar {
      /* background: pink; */
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .heading {
      margin: 0 0.5rem;
    }
    cursor: pointer;
    // projects view – show / hide
    transition: opacity .5s .25s, visibility 0s .75s;
    .projects--projectview &{
      transition: opacity .25s, visibility 0s .25s;
      opacity:0;
      &:hover{
        transition: opacity .5s, visibility 0s;
        opacity:1;
      }
    }
  }

  .thumbs{
    $gutter: (50px/$rem)*1rem;
    max-width:(774px/$doc-font)*1em;
    margin:0 auto;
    padding:$gutter $gutter/2 0;
    @include clearFloat();

    > div{
      width:(100%/3);
      padding:0 $gutter/2;
      float:left;
      margin-bottom: $gutter;

      a{
        display:block;
        width:100%;
        padding-bottom:142.85%;
        background-size:cover;
        background-position:center center;
        background-repeat:no-repeat;
        cursor: pointer;
      }
    }
  }

  #viewer{
    position:relative;
    overflow:hidden; // ffx
    width:100%;
    height:100vh;
    height: calc(var(--vh, 1vh) * 100);
    cursor: url(../assets/icons/cursor-dot.png) 9 9, auto;
    cursor: -webkit-image-set(
      url(../assets/icons/cursor-dot.png) 1x,
      url(../assets/icons/cursor-dot@2x.png) 2x
    ) 9 9, auto;
    > *{
      @include background(absolute);
    }
  }
  
@include onMobile() {
  .thumbs{
    padding:$pad $pad/2;
    > div{
      width: 50%;
      padding:0 $pad/2;
      margin-bottom: $pad;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Projects.vue?b21b6e5e